import React from "react";

export function PressReleases() {
  return (
    <div className="fqxi-shortcodes-pressReleases"></div>
  );
}
